import React,{Component} from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {getOrderAckowledge} from '../../actions/orderFulfillment';
import { imgs } from '../common/MangoIcons'
class OrderPack extends Component {
    constructor() {
        super()
        
        this.state = {
            or_details : []
        }

    }

    componentDidMount=()=>{
        
        this.props.getOrderAckowledge(this.props.connection_id)
       // localStorage.removeItem('cart')
      /*   if(this.state.or_details.length == 0){
            this.setState({
                or_details : []
            })
        } */
    }
     objectToQueryString=(obj)=> {
        var str = [];
        for (var p in obj)
          if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        return str.join("&");
      }
      
      
     
    render(){
        
       const  or_details = this.props.or_details.ords

        return(
           <React.Fragment>
               <section>
               <div style={{ paddingBottom: 15 }}>
                                    <h5 style={{ textAlignLast: 'center' }}>Pack Order</h5>
                                </div>
               <div className='container ack-main'>
{or_details && or_details.length > 0 ?

<React.Fragment>

                 {  or_details.map((od,index)=>{
/* 
<React.Fragment>

                     {od.fo_status === "NOT ACKNOWLEDGED" ? '' : ''}
</React.Fragment> */ 




                      let dateTime = od.fo_date;
                      let date = dateTime.substr(0,10);
                      var queryString=this.objectToQueryString(od.item_details);
                      let path = '/packdetail?fo_no='+od.fo_no+'&fo_date='+date+'&co_no='+od.co_no;                  return (

                    <React.Fragment key={index}>
                     {od.fo_status === "PICKSLIP GENERATED" ? 
<div>
                   <div className='row'>
                       <div className='col'><b>FO No</b></div>
                       <div className='col-1'>:</div>
                       <div className='col'><b>{od.fo_no}</b></div>
                   </div>
                    
                   <div className='row'>
                       <div className='col'>FO Date</div>
                       <div className='col-1'>:</div>
                       <div className='col'>{date}</div>
                   </div>
                   <div className='row'>
                       <div className='col'>FO Age</div>
                       <div className='col-1'>:</div>
                       <div className='col'>{od.fo_age}</div>
                   </div> <div className='row'>
                       <div className='col'>CO No</div>
                       <div className='col-1'>:</div>
                       <div className='col'>{od.co_no}</div>
                   </div> <div className='row'>
                       <div className='col'>Order Channel</div>
                       <div className='col-1'>:</div>
                       <div className='col'>{od.order_channel}</div>
                   </div> <div className='row'>
                       <div className='col'>Order Sub Channel</div>
                       <div className='col-1'>:</div>
                       <div className='col'>{od.order_sub_channel}</div>
                   </div>
                   
                   <div className='row' style={{padding:'0px 20px'}}>
                       <div className='col'> <Link to={path}>
                       <img src={imgs} alt="" style={{width: '9%'
,    float: 'right'}}/></Link>
                       </div>
                            </div>
                            
                            <hr/>
                            </div>
                             : '' } 
                            </React.Fragment>
                 )}) } 
                    
                    </React.Fragment>    : '' 

    }
               </div></section>
           </React.Fragment>
        ) 
       
    }
}
const mapStateToProps = (state, ownProps) => ({
    connection_id: state.tenant.connection_id,
    or_details: state.orderFulfillment



});


const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getOrderAckowledge },
        dispatch
    );


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(OrderPack));

